// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__bkN5m","title":"styles_title__4_65r","graph":"styles_graph__Q_nt4","wrapper-thumb":"styles_wrapper-thumb__pcHx5","cta":"styles_cta__pvII4"};